<template>
  <section class="section-base section-color section-overflow-top">
    <div class="container">
      <div class="grid-list" data-columns="3" data-columns-md="1">
        <div class="grid-box">
          <div class="grid-item">
            <div class="cnt-box cnt-box-info boxed" data-href="#">
              <a href="#" class="img-box">
                <img :src="require('Assets/images/modulos.jpg')" alt="">
              </a>
              <div class="caption">
                <h3>MÓDULOS</h3>

              </div>
            </div>
          </div>
          <div class="grid-item">
            <div class="cnt-box cnt-box-info boxed" data-href="#">
              <a href="#" class="img-box">
                <img :src="require('Assets/images/inversores.jpg')" alt="">
              </a>
              <div class="caption">
                <h3>INVERSORES</h3>
              </div>
            </div>
          </div>
          <div class="grid-item">
            <div class="cnt-box cnt-box-info boxed" data-href="#">
              <a href="#" class="img-box">
                <img :src="require('Assets/images/estruturas.jpg')" alt="">
              </a>
              <div class="caption">
                <h3>ESTRUTURAS E COMPONENTES</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ProdutosCategorias',
};
</script>

<style scoped>
.section-base{
  margin-top: -76px;
}
</style>
